import { Check, Plug } from "lucide-react";
import { cn } from "@/utils/cn";
import { CardFooter, IconBadge, PrimaryButton, WizardCard } from "./visuals";

/**
 * Step 1: the agent model (Jurídico, RH...). Models without a package yet show
 * as "Em breve" and cannot be picked. "Do zero" opens the Touch Builder.
 */
export default function StepModels({ models, selected, onSelect, onNext, onBlank }) {
  return (
    <>
      <div role="radiogroup" aria-label="Modelos de agente" className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {models.map((model) => {
          const isSelected = selected === model.id;
          return (
            <WizardCard
              key={model.id}
              as="button"
              type="button"
              role="radio"
              aria-checked={isSelected}
              aria-disabled={!model.available}
              disabled={!model.available}
              selected={isSelected}
              muted={!model.available}
              onClick={() => model.available && onSelect(model.id)}
              className={cn("min-h-[196px]", model.available && "hover:border-foreground/40")}
            >
              <span className="flex items-center gap-3.5 px-5 pt-5">
                <IconBadge icon={model.icon} tone={model.tone} />
                <span className="flex-1 text-[17px] font-semibold text-foreground">{model.label}</span>
                {isSelected && (
                  <span aria-hidden="true" className="flex h-[22px] w-[22px] items-center justify-center rounded-full bg-foreground text-background">
                    <Check className="h-3 w-3" strokeWidth={3} />
                  </span>
                )}
              </span>
              <span className="block px-5 pb-5 pt-3 text-sm leading-relaxed text-muted-foreground">{model.description}</span>
              <CardFooter className="justify-between">
                <span>{model.audience}</span>
                {model.available ? (
                  <span className="inline-flex items-center gap-1.5">
                    <Plug className="h-3.5 w-3.5" aria-hidden="true" />
                    {model.systems.length} sistemas
                  </span>
                ) : (
                  <span>Em breve</span>
                )}
              </CardFooter>
            </WizardCard>
          );
        })}
        <button
          type="button"
          onClick={onBlank}
          className="flex min-h-[196px] flex-col items-center justify-center gap-2.5 rounded-2xl border border-dashed border-black/[.15] bg-white text-foreground hover:border-foreground/40 dark:border-white/20 dark:bg-transparent"
        >
          <IconBadge icon="plus" tone="gray" />
          <span className="text-base font-semibold">Do zero</span>
          <span className="text-sm text-muted-foreground">No Touch Builder</span>
        </button>
      </div>

      <div className="mt-8 flex justify-end">
        <PrimaryButton onClick={onNext} disabled={!selected}>
          Continuar
        </PrimaryButton>
      </div>
    </>
  );
}
